import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import {hotModuleReplacement} from './hot-store';
import { DevModule } from './dev.module';

export function bootstrapDevModule() {
  hotModuleReplacement(() => platformBrowserDynamic().bootstrapModule(DevModule), module);
}





// WEBPACK FOOTER //
// ./src/setup/dev.bootstrap.ts